export default __webpack_public_path__ + "static/media/smedetoften-tenancy-04.2bf8d4d5.jpg";